import IconWithText from '../icon-with-text/IconWithText.component';
import { RecommendationContentTypeDto } from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import { RemediationContentTypeConfigMap } from '../../models/remediation.models';

export type ContentTypeDisplayProps = {
  contentType: RecommendationContentTypeDto;
}
export const ContentTypeDisplay = (props: ContentTypeDisplayProps): JSX.Element => {
  const config = RemediationContentTypeConfigMap[props.contentType];

  if (!config) {
    return null;
  }

  return (
    <IconWithText
      iconName={config.iconName}
      iconPrefix={config.iconPrefix}
    >
      {config.displayName}
    </IconWithText>
  );
};
